<template>
	<div class="">
		<el-breadcrumb separator-class="el-icon-arrow-right" class="m-b-20 breadcrumb-pc">
			<el-breadcrumb-item class="color_A6A6A6"><span class="com_pointer" @click="$router.push('/pass')">知识宝典</span></el-breadcrumb-item>
			<el-breadcrumb-item>答题记录</el-breadcrumb-item>
		</el-breadcrumb>

		<!-- PC端表格 -->
		<div class="table-pc">
			<el-table :data="records" v-loading="loading" style="width: 100%;" stripe>
				<el-table-column prop="paper_name" label="试卷名称" min-width="200"></el-table-column>
				<el-table-column prop="user_score" label="得分" width="100" align="center">
					<template slot-scope="scope">
						<span :class="scope.row.is_pass ? 'color_green' : 'color_red'" class="font_weight">
							{{ scope.row.user_score }}
						</span>
					</template>
				</el-table-column>
				<el-table-column prop="total_score" label="满分" width="80" align="center"></el-table-column>
				<el-table-column label="结果" width="100" align="center">
					<template slot-scope="scope">
						<el-tag :type="scope.row.is_pass ? 'success' : 'danger'" size="small">
							{{ scope.row.is_pass ? '通过' : '未通过' }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="time_used_text" label="用时" width="100" align="center"></el-table-column>
				<el-table-column prop="create_at" label="答题时间" width="180" align="center"></el-table-column>
				<el-table-column label="操作" width="100" align="center">
					<template slot-scope="scope">
						<el-button type="text" size="small" @click="viewDetail(scope.row)">查看详情</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<!-- 移动端卡片列表 -->
		<div class="cards-mobile" v-loading="loading">
			<div class="record-card" v-for="(item, index) in records" :key="index" @click="viewDetail(item)">
				<div class="record-card-header">
					<span class="record-card-title">{{ item.paper_name }}</span>
					<el-tag :type="item.is_pass ? 'success' : 'danger'" size="mini">
						{{ item.is_pass ? '通过' : '未通过' }}
					</el-tag>
				</div>
				<div class="record-card-body">
					<div class="record-card-info">
						<span>得分：<b :class="item.is_pass ? 'color_green' : 'color_red'">{{ item.user_score }}</b> / {{ item.total_score }}</span>
						<span>用时：{{ item.time_used_text }}</span>
					</div>
					<div class="record-card-time">
						<span>{{ item.create_at }}</span>
						<span class="view-detail-link">查看详情 &gt;</span>
					</div>
				</div>
			</div>
		</div>

		<div v-if="!loading && records.length === 0" class="text_c p-30">
			<i class="el-icon-document" style="font-size: 60px; color: #ccc;"></i>
			<p class="color_999 m-t-10">暂无答题记录</p>
			<el-button type="primary" size="small" class="m-t-10" @click="$router.push('/pass')"
				style="background-color: #163F88; border-color: #163F88;">去答题</el-button>
		</div>

		<!-- 答题详情弹窗 -->
		<el-dialog :title="detailTitle" :visible.sync="detailVisible" width="800px" top="5vh" class="detail-dialog" :close-on-click-modal="false">
			<div v-loading="detailLoading" class="detail-content">
				<!-- 概览信息 -->
				<div class="detail-summary" v-if="detailData">
					<div class="summary-item">
						<span class="summary-label">试卷：</span>
						<span>{{ detailData.paper_name }}</span>
					</div>
					<div class="summary-item">
						<span class="summary-label">得分：</span>
						<span :class="detailData.is_pass ? 'color_green' : 'color_red'" class="font_weight">{{ detailData.user_score }}</span>
						<span> / {{ detailData.total_score }}</span>
					</div>
					<div class="summary-item">
						<span class="summary-label">结果：</span>
						<el-tag :type="detailData.is_pass ? 'success' : 'danger'" size="small">
							{{ detailData.is_pass ? '通过' : '未通过' }}
						</el-tag>
					</div>
					<div class="summary-item">
						<span class="summary-label">正确/错误：</span>
						<span class="color_green">{{ detailData.correct_count }}题正确</span>
						<span class="m-l-10 color_red">{{ detailData.wrong_count }}题错误</span>
					</div>
				</div>

				<!-- 题目详情列表 -->
				<div class="detail-questions" v-if="detailData && detailData.answers && detailData.answers.length">
					<div class="question-item" v-for="(q, idx) in detailData.answers" :key="idx" :class="{'question-correct': q.is_correct, 'question-wrong': !q.is_correct}">
						<div class="question-header">
							<span class="question-index">{{ idx + 1 }}.</span>
							<span class="question-type-tag">{{ getTypeName(q.type) }}</span>
							<span class="question-score">（{{ q.score }}分）</span>
							<el-tag :type="q.is_correct ? 'success' : 'danger'" size="mini" class="m-l-10">
								{{ q.is_correct ? '正确' : '错误' }}
							</el-tag>
						</div>
						<div class="question-name">{{ q.name }}</div>
						<div class="question-options" v-if="q.items && q.items.length">
							<div class="option-item" v-for="(opt, oi) in q.items" :key="oi"
								:class="{
									'option-correct': isCorrectOption(q, opt.key),
									'option-wrong': isUserWrongOption(q, opt.key),
									'option-user-selected': isUserSelected(q, opt.key)
								}">
								<span class="option-key">{{ opt.key }}.</span>
								<span class="option-value">{{ opt.value }}</span>
								<i v-if="isCorrectOption(q, opt.key)" class="el-icon-check option-icon color_green"></i>
								<i v-if="isUserWrongOption(q, opt.key)" class="el-icon-close option-icon color_red"></i>
							</div>
						</div>
						<div class="question-answer-info">
							<div><span class="answer-label">你的答案：</span><span :class="q.is_correct ? 'color_green' : 'color_red'">{{ q.user_answer || '未作答' }}</span></div>
							<div><span class="answer-label">正确答案：</span><span class="color_green">{{ q.right_answer }}</span></div>
						</div>
						<div class="question-analysis" v-if="q.analysis">
							<span class="analysis-label">解析：</span>
							<span>{{ q.analysis }}</span>
						</div>
					</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>
<script>
export default {
	name: "PassRecords",
	data() {
		return {
			loading: false,
			records: [],
			detailVisible: false,
			detailLoading: false,
			detailData: null,
			detailTitle: '答题详情',
		};
	},
	activated() {
		if (!localStorage.getItem('u_token')) {
			this.$message.info('请先登录！');
			this.$router.push('/login');
			return;
		}
		this.getRecords();
	},
	methods: {
		getRecords() {
			this.loading = true;
			this.$api.authPass.getRecords({}).then((res) => {
				if (res.code == 1) {
					this.records = ((res.data && res.data.data) || []).map(r => {
						const mins = Math.floor((r.time_used || 0) / 60);
						const secs = (r.time_used || 0) % 60;
						r.time_used_text = `${mins}分${secs}秒`;
						return r;
					});
				}
			}).catch(() => {}).finally(() => {
				this.loading = false;
			});
		},
		viewDetail(record) {
			this.detailTitle = `答题详情 - ${record.paper_name}`;
			this.detailVisible = true;
			this.detailLoading = true;
			this.detailData = null;
			this.$api.authPass.getRecordDetail({ record_id: record.id }).then((res) => {
				if (res.code == 1) {
					this.detailData = res.data;
				} else {
					this.$message.error(res.info || '获取详情失败');
				}
			}).catch(() => {
				this.$message.error('网络错误');
			}).finally(() => {
				this.detailLoading = false;
			});
		},
		getTypeName(type) {
			const map = { 1: '判断题', 2: '单选题', 3: '多选题', 4: '不定项选择' };
			return map[type] || '未知';
		},
		isCorrectOption(q, key) {
			const rightArr = (q.right_answer || '').toUpperCase().split(',').map(s => s.trim());
			return rightArr.includes(key.toUpperCase());
		},
		isUserSelected(q, key) {
			const userArr = (q.user_answer || '').toUpperCase().split(',').map(s => s.trim());
			return userArr.includes(key.toUpperCase());
		},
		isUserWrongOption(q, key) {
			return this.isUserSelected(q, key) && !this.isCorrectOption(q, key);
		}
	}
};
</script>
<style scoped>
.color_green { color: #67C23A; }
.color_red { color: #F56C6C; }

/* 详情弹窗样式 */
.detail-summary {
	display: flex;
	flex-wrap: wrap;
	gap: 20px;
	padding: 15px 20px;
	background: #f8f9fa;
	border-radius: 8px;
	margin-bottom: 20px;
}
.summary-item {
	font-size: 14px;
}
.summary-label {
	color: #999;
}
.detail-questions {
	max-height: 60vh;
	overflow-y: auto;
	padding-right: 10px;
}
.question-item {
	padding: 15px 20px;
	margin-bottom: 15px;
	border-radius: 8px;
	border: 1px solid #eee;
	background: #fff;
}
.question-item.question-correct {
	border-left: 4px solid #67C23A;
}
.question-item.question-wrong {
	border-left: 4px solid #F56C6C;
}
.question-header {
	display: flex;
	align-items: center;
	margin-bottom: 8px;
}
.question-index {
	font-weight: bold;
	margin-right: 5px;
}
.question-type-tag {
	background: #e8f0fe;
	color: #163F88;
	padding: 2px 8px;
	border-radius: 4px;
	font-size: 12px;
	margin-right: 8px;
}
.question-score {
	color: #999;
	font-size: 13px;
}
.question-name {
	font-size: 14px;
	line-height: 1.6;
	margin-bottom: 10px;
	color: #333;
}
.question-options {
	margin-bottom: 10px;
}
.option-item {
	padding: 6px 12px;
	margin-bottom: 4px;
	border-radius: 4px;
	font-size: 13px;
	display: flex;
	align-items: center;
	position: relative;
}
.option-item.option-correct {
	background: #f0f9eb;
}
.option-item.option-wrong {
	background: #fef0f0;
}
.option-item.option-user-selected {
	font-weight: bold;
}
.option-key {
	margin-right: 8px;
	font-weight: bold;
}
.option-icon {
	margin-left: auto;
	font-size: 16px;
}
.question-answer-info {
	display: flex;
	gap: 20px;
	font-size: 13px;
	margin-bottom: 8px;
	padding: 8px 12px;
	background: #fafafa;
	border-radius: 4px;
}
.answer-label {
	color: #999;
}
.question-analysis {
	font-size: 13px;
	color: #666;
	padding: 8px 12px;
	background: #fffbe6;
	border-radius: 4px;
	border-left: 3px solid #e6a23c;
}
.analysis-label {
	color: #e6a23c;
	font-weight: bold;
}

/* 移动端卡片默认隐藏 */
.cards-mobile {
	display: none;
}
.view-detail-link {
	color: #163F88;
	font-size: 12px;
}

@media screen and (max-width: 768px) {
	.table-pc {
		display: none;
	}
	.breadcrumb-pc {
		display: none;
	}
	.cards-mobile {
		display: block;
	}
	.record-card {
		background: #fff;
		border-radius: 8px;
		padding: 15px;
		margin-bottom: 12px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
		cursor: pointer;
	}
	.record-card:active {
		background: #f5f5f5;
	}
	.record-card-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 10px;
	}
	.record-card-title {
		font-weight: bold;
		font-size: 14px;
		flex: 1;
		margin-right: 10px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.record-card-body {
		font-size: 13px;
		color: #666;
	}
	.record-card-info {
		display: flex;
		justify-content: space-between;
		margin-bottom: 6px;
	}
	.record-card-time {
		font-size: 12px;
		color: #999;
		display: flex;
		justify-content: space-between;
	}
	/* 移动端弹窗适配 */
	.detail-summary {
		flex-direction: column;
		gap: 10px;
		padding: 12px 15px;
	}
	.question-answer-info {
		flex-direction: column;
		gap: 5px;
	}
}
</style>
<style>
/* 移动端弹窗全屏 */
@media screen and (max-width: 768px) {
	.detail-dialog .el-dialog {
		width: 95% !important;
		margin-top: 3vh !important;
	}
}
</style>
